import { render, staticRenderFns } from "./LearningResources.vue?vue&type=template&id=9ae89c9a&scoped=true"
import script from "./LearningResources.vue?vue&type=script&lang=js"
export * from "./LearningResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae89c9a",
  null
  
)

export default component.exports